import { defRoute } from '@components/router';
import { useEffect } from 'preact/hooks';

async function clearSession() {
  // Clear cache storage
  try {
    // This throws an exception in Firefox private browsing mode.
    // So it's okay to swallow the error.
    const cacheNames = await window.caches.keys();
    cacheNames.forEach((name) => {
      window.caches.delete(name);
    });
  } catch (err) {
    console.log(err);
  }

  // Clear localStorage, preserving one-time flags
  const preserveKeys = ['aip-welcome-seen'];
  const preserved = preserveKeys.map((k) => [k, window.localStorage.getItem(k)] as const);
  window.localStorage.clear();
  for (const [k, v] of preserved) {
    if (v !== null) {
      window.localStorage.setItem(k, v);
    }
  }

  // Clear sessionStorage
  window.sessionStorage.clear();
}

export const route = defRoute({
  isPublic: true,
  Page({ params, auth, router }) {
    let href = params.goto || '';
    if (!href.startsWith('/')) {
      href = '/login';
    }
    useEffect(() => {
      auth.logout().then(() => {
        router.goto(href);
        clearSession();
      });
    }, []);
    return null;
  },
});
